
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getUsers(pageUrl=null) {
        let queryString;
        if (typeof pageUrl === 'string') {
            queryString = new URLSearchParams(pageUrl).toString();
        } else if (typeof pageUrl === 'object' && pageUrl !== null) {
            const params = new URLSearchParams();
            if (pageUrl.search) params.append('search', pageUrl.search);
            if (pageUrl.page) params.append('page', pageUrl.page);
            if (pageUrl.from) params.append('from', pageUrl.from);
            if (pageUrl.to) params.append('to', pageUrl.to);
            queryString = params.toString();
        } else {
            queryString = '';
        }
        const url = `${API_URL}/users?${queryString}`; 
        
        return axios.get(url, { headers: authHeader() });
    },
    getAll(pageUrl=null) {
        if (pageUrl === 'all') {
            const url = `${API_URL}/users?page=all`; 
            return axios.get(url, { headers: authHeader() });
        }
        const url = `${API_URL}/users?page=${pageUrl || 1}`; 
        return axios.get(url, { headers: authHeader() });
    },
    getUser(userId) {
        return axios.get(`${API_URL}/users/${userId}`, { headers: authHeader() });
    },
    createUser(userData) {
        return axios.post(`${API_URL}/users`, userData, { headers: authHeader() });
    },
    updateUser(userId, userData) {
        return axios.put(`${API_URL}/users/${userId}`, userData, { headers: authHeader() });
    },
    deleteUser(userId) {
        return axios.delete(`${API_URL}/users/${userId}`, { headers: authHeader() });
    },
    getOficios() {
        const url = `${API_URL}/oficios`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
};